/**
 * The Actions "quantity" buttons are coded as radio inputs with the button role bolted on,
 * so that assistive technology will recognize them as toggle buttons.
 * In order to make these radio buttons behave like toggle buttons, too,
 * we need to adjust how they behave to certain keystrokes.
 * @param {KeyboardEvent} event
 */
export const handleQuantityButtonKeydown = (event) => {
  // Grab event.key for IE11
  const key = event.code || event.key

  if (key === keys.TAB && event.shiftKey && $(event.target).parent().is(':not(:first-of-type)')) {
    event.preventDefault()
    $(event.target).parent().prevAll('.atom-input-radio-and-label').first().find('input').focus()
  } else if (key === keys.TAB && !event.shiftKey && !$(event.target).parent().is(':last-of-type')) {
    // Tab to the next quantity button, or the next interactive element in the focus order
    event.preventDefault()
    $(event.target).parent().nextAll('.atom-input-radio-and-label').first().find('input').focus()
  } else if ([keys.LEFT, keys.RIGHT, keys.DOWN, keys.UP].includes(key)) {
    // Prevent the user from making a new selection when they press the right or left arrow key,
    // and prevent the user from navigating across options when they press the down or up arrow key
    event.preventDefault()
  } else if (key === keys.ENTER) {
    // Re-create toggle button functionality
    $(event.target).trigger('click')
  }
}

/**
 * When the user tabs on to the first quantity selection button,
 * prevent the default event.
 * @param {KeyboardEvent} event
 */
export const handleQuantityButtonKeyup = (event) => {
  // Grab event.key for IE11
  const key = event.code || event.key

  if (key === keys.TAB && !$(event.target).parent().is(':first-of-type')) {
    // Tab to the next quantity button, or the next interactive element in the focus order
    event.preventDefault()
  }
}
